import React from "react";
import { doc, setDoc} from "firebase/firestore";
import { db } from "../../firebase-config";
import { lecturersState } from "../../atoms";
import { useRecoilValue } from "recoil";
const lecturersListJSON = require("./lecturersListFiltered.json");

export const AddLecturers = () => {
  const lecturersInRecoil = useRecoilValue(lecturersState);
  //console.log("In recoil", lecturersInRecoil);
  const [collectionName, setCollectionName] = React.useState("Lecturers2");
  const addLecturers = React.useCallback(async () => {
    // run concurrent promises for the entire list of lecturers
    try {
      lecturersListJSON.forEach(async (lecturer, i) => {
        await setDoc(doc(db, collectionName, i.toString()), {
          id: i,
          name: lecturer.name,
          averageRating1: 0,
          averageRating2: 0,
          averageRating3: 0,
          numberOfRatings: 0,
        });
      });
    } catch (error) {
      //console.log(error);
    }
  }, [collectionName]);
  return (
    <div>
      <span>There are {lecturersInRecoil.length} lecturers in db</span>
      <form>
        <input
          value={collectionName}
          onChange={(e) => setCollectionName(e.target.value)}
        ></input>
      </form>
      <button onClick={addLecturers}>AddLecturers</button>
    </div>
  );
};
